@if (hasError()) {
  <div class="callback-container">
    <div class="callback-card">
      <img ngSrc="assets/images/logo_unnamed.png" alt="Ankata" class="logo" />
      <h2>Échec de la connexion</h2>
      <p class="message">Une erreur est survenue lors de l'authentification.</p>
      <button mat-flat-button color="primary" (click)="retry()">Réessayer</button>
    </div>
  </div>
} @else {
  <div class="callback-container">
    <div class="callback-card">
      <img src="assets/images/logo_unnamed.png" alt="Ankata" class="logo" />
      <h2>Connexion en cours</h2>
      <mat-spinner diameter="48" />
      <p class="message">Chargement de vos données, veuillez patienter…</p>
    </div>
  </div>
}
